import styled from 'foundations-theming/utils';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledPanelHeaderContainer = styled.div.withConfig({
  displayName: "EnrollmentActionConfigHeader__StyledPanelHeaderContainer",
  componentId: "sc-1pqdx73-0"
})(["background:", ";color:", ";border-bottom:1px solid ", ";height:50px;padding-top:4px;padding-bottom:4px;padding-left:12px;padding-right:8px;display:flex;justify-content:space-between;align-items:center;flex-shrink:0;"], ({
  theme
}) => theme.color['do-not-use-gypsum'], ({
  theme
}) => theme.color['do-not-use-obsidian'], ({
  theme
}) => theme.color['do-not-use-battleship']);
const StyledHeaderTitle = styled.div.withConfig({
  displayName: "EnrollmentActionConfigHeader__StyledHeaderTitle",
  componentId: "sc-1pqdx73-1"
})(["align-self:center;padding-right:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;hyphens:none;"]);
const StyledH5 = styled.h5.withConfig({
  displayName: "EnrollmentActionConfigHeader__StyledH5",
  componentId: "sc-1pqdx73-2"
})(["margin-bottom:unset;display:inline;"]);
const EnrollmentActionConfigHeader = ({
  header,
  showBackButton,
  onBack,
  children,
  enrollmentPath,
  reenrollmentPath,
  unenrollmentPath,
  style,
  shouldHideTabs
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledPanelHeaderContainer, {
      style: style,
      children: [/*#__PURE__*/_jsxs(StyledHeaderTitle, {
        children: [showBackButton && /*#__PURE__*/_jsx(UIIconButton, {
          onClick: onBack,
          "aria-label": I18n.text('automation-ui-enrollment.redesign.enrollSelection.previousStep'),
          use: "unstyled",
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: "left",
            className: "m-right-1"
          })
        }), /*#__PURE__*/_jsx(StyledH5, {
          children: header
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: children
      })]
    }), !shouldHideTabs && /*#__PURE__*/_jsxs(UIRouterTabs, {
      fill: true,
      style: {
        marginBottom: 1 /* We alter the body background of certain UIPanels which are transparent by default. Without the transparency, the bottom border of the tab bar can be covered so we utilize a 1px margin to ensure the border is always visible */
      },
      children: [/*#__PURE__*/_jsx(UIRouterTab, {
        exact: true,
        to: enrollmentPath || '',
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollSelection.tabs.enrollment"
        })
      }), /*#__PURE__*/_jsx(UIRouterTab, {
        exact: true,
        to: unenrollmentPath || '',
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollSelection.tabs.unenrollment"
        })
      }), /*#__PURE__*/_jsx(UIRouterTab, {
        "data-test-id": "platform-reenrollment-tab",
        disabled: !reenrollmentPath,
        to: reenrollmentPath || '',
        tabId: "reenrollment",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.enrollSelection.tabs.reenrollment"
        })
      })]
    })]
  });
};
export default EnrollmentActionConfigHeader;